// Original source: https://github.com/flyingsparx/s3upload-coffee-javascript/blob/master/s3upload.js
// Modified to match our needs

import { contentFromFile } from './s3Upload';

export default {

  s3_sign_put_url: '/proxy/contracting/saveComment/',

  s3uploadAndOrSaveComent({ contractId, files, historyFeedId, message }) {
    return this.executeOnSignedUrl(contractId, files, historyFeedId, message)
        .then(res => {
          const fileMap = files.length ? files.reduce((map, file) => ({ ...map, [file.name]: file }), {}) : [];
          return Promise.all(
            (files.length ? res.files.map(({ fileName, signedUrl, downloadUrl }) =>
                          this.uploadToS3(fileMap[fileName], signedUrl, downloadUrl, fileName)
                        ) : []))
            .then(uploadedFiles => ({ files: uploadedFiles, comment: res.comment }));
        });
  },

  executeOnSignedUrl(contractId, files, historyFeedId, message) {
    return fetch(`/proxy/contracting/saveComment/${historyFeedId}`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        files: files.map(({ type, name, size }) => ({ type, name, size })),
        message,
        contractId,
      }),
    })
    .then(res => res.json())
    .catch(err => console.log(err));
  },

  uploadToS3(file, url, publicUrl, fileName) {
    if (!url) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const xhr = this.createCORSRequest('PUT', url);
      xhr.onload = function () {
        if (xhr.status === 200) resolve({ downloadUrl: publicUrl, fileName });
        return reject(`Upload error: ${xhr.status}`);
      };
      xhr.onerror = function () {
        reject('XHR error.');
      };
      const contentType = contentFromFile(file);
      if (contentType) xhr.setRequestHeader('Content-Type', contentType);
      // xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.send(file);
    });
  },

  createCORSRequest(method, url) {
    let xhr = new XMLHttpRequest();
    if (xhr.withCredentials !== null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }
    return xhr;
  },

};



// WEBPACK FOOTER //
// ./src/app/utils/s3ContractingFilesUpload.js